export default __webpack_public_path__ + "static/media/selected.0cce5232.svg";